import { render, staticRenderFns } from "./PiuInformazioniPartner.vue?vue&type=template&id=1507be7a&scoped=true&"
import script from "./PiuInformazioniPartner.vue?vue&type=script&lang=js&"
export * from "./PiuInformazioniPartner.vue?vue&type=script&lang=js&"
import style0 from "./PiuInformazioniPartner.vue?vue&type=style&index=0&id=1507be7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507be7a",
  null
  
)

export default component.exports